module.exports = __webpack_public_path__ + "img/13.ec1c2360.png";